export default __webpack_public_path__ + "static/media/l_wdt_c_4.41819756.mp3";